import { render, staticRenderFns } from "./StartupsModal.vue?vue&type=template&id=fcede39a&scoped=true&"
import script from "./StartupsModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./StartupsModal.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcede39a",
  null
  
)

export default component.exports